/* eslint-disable no-else-return */
/* eslint-disable prefer-template */
/* eslint-disable no-plusplus */
/* eslint-disable radix */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react/button-has-type */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import Editor from '@monaco-editor/react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { IApiResult } from '../../interface/IApiResult';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyAlert } from '../UI/MyAlert';
import { ContentDto } from '../../dto/ContentDto';
import { apiSaveAbstract3DNew } from '../../service/apiSaveAbstract3DNew';
import { TextDto } from '../../dto/TextDto';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import styles from './Dialog.module.css';
import { apiGetAbstract3DNew } from '../../service/apiGetAbstract3DNew';
import { AtlasNewDto } from '../../dto/AtlasNewDto';
import { apiGetAtlas3DNew } from '../../service/apiGetAtlas3DNew';
import { MyAutoComplete } from '../UI/MuAutoComplete';
import { DialogTestAddToAbstract } from './DialogTestAddToAbstract';
import { TestDto } from '../../dto/TestDto';

// Импорт Monaco Editor

interface Props {
  open: boolean;
  isEdit?: boolean;
  onClose: () => void;
  dto?: ContentDto;
}

export const DialogAbstract3DNew: FunctionComponent<Props> = ({
  open,
  dto,
  isEdit,
  onClose,
}) => {
  const [openAddTest, setOpedAddTest] = useState(false);

  const [markdown, setMarkdown] = useState<string>('');
  const [markdownEditor, setMarkdownEditor] = useState<string>('');
  const [history, setHistory] = useState<string[]>([]);
  const [historyIndex, setHistoryIndex] = useState<number>(-1);
  const previewRef = useRef<HTMLDivElement>(null);

  // Реф для Monaco Editor
  const editorRef = useRef<any>(null);

  const [atlas, setAtlas] = useState<AtlasNewDto[]>([]);
  const [atlasAdd, setAtlasAdd] = useState<AtlasNewDto>({
    angl: '',
    atlasId: '',
    id: '',
    latGaivar: '',
    latPr: '',
    latSech: '',
    latSmew: '',
    rus: '',
    scene: '',
    rusPr: '',
    rusSech: '',
    rusGaivar: '',
  });

  const [type, setType] = useState(0);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [backDrop, setBackDrop] = useState(false);
  const { section } = useParams();

  const getIdArray = (array: any) => {
    const arrId = [];
    for (let i = 0; i < array.length; i += 1) {
      arrId.push(array[i].atlasId);
    }
    return arrId;
  };

  const getNameArray = (array: any, typeFind: number) => {
    const arrName = [];
    for (let i = 0; i < array.length; i += 1) {
      if (typeFind === 0) {
        arrName.push(array[i].latSmew.replaceAll('_', '"'));
      }
      if (typeFind === 1) {
        arrName.push(array[i].latPr.replaceAll('_', '"'));
      }
      if (typeFind === 2) {
        arrName.push(array[i].latSech.replaceAll('_', '"'));
      }
      if (typeFind === 3) {
        arrName.push(array[i].latGaivar.replaceAll('_', '"'));
      }
    }
    return arrName;
  };

  // Обработка инлайн-разметки
  const processInlineMarkdown = (text: string): string =>
    text
      .replace(
        /\*\*(.*?)\*\*/g,
        `<strong class="${styles.previewStrong}">$1</strong>`
      )
      .replace(/\*(.*?)\*/g, `<em class="${styles.previewEm}">$1</em>`)
      .replace(/`(.*?)`/g, `<code class="${styles.previewCode}">$1</code>`)
      .replace(
        /!\[(.*?)\]\((.*?)\)/g,
        `<img alt="$1" src="$2" class="${styles.previewImage}" />`
      )
      .replace(
        /\[(.*?)\]\((http.*?)\)/g,
        `<a href="$2" target="_blank" class="${styles.previewLink}">$1</a>`
      );

  // Экранирование HTML
  const escapeHtml = (text: string): string => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  // Замена переносов строк перед ---
  const rereplaceMarkdpwn = (text: string): string => {
    let replacetetxt = text;
    replacetetxt = replacetetxt.replaceAll(
      '\r\n\r\n\r\n\r\n---',
      '\n&nbsp;---'
    );
    replacetetxt = replacetetxt.replaceAll('\r\n\r\n\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\r\n\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n---', '\n&nbsp;---');
    return replacetetxt;
  };

  // Предобработка Markdown для списков
  const preprocessMarkdown = (text: string): string => {
    const lines = text.split('\n');
    let inNumberedList = false;
    let counter = 0;
    let currentLevel = 0;

    const processed = lines.map((line) => {
      const trimmed = line.trim();
      const numberedMatch = line.match(
        /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/
      );
      const bulletMatch = line.match(/^[-*+]\s/);
      const isEmpty = trimmed === '';
      const isHeading = /^#{1,6}\s/.test(trimmed);

      if (isEmpty || isHeading) {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      }

      if (numberedMatch) {
        const numberStr = numberedMatch[1];
        const levels = numberStr.split('.').map(Number);
        currentLevel = levels.length;
        counter = levels[levels.length - 1] || 1;
        inNumberedList = true;
        return line;
      } else if (bulletMatch && inNumberedList) {
        return line;
      } else if (bulletMatch) {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      } else {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      }
    });

    return processed.join('\n');
  };

  // Рендеринг Markdown в HTML
  const renderMarkdown = (text: string): string => {
    if (!text) return '';

    const preprocessedText = preprocessMarkdown(text);
    const processedText = rereplaceMarkdpwn(preprocessedText);
    const lines = processedText.split('\n');
    let inCodeBlock = false;
    let inList = false;
    let listTag = 'ol';
    let listBuffer: string[] = [];
    let currentListLevel = 0;
    let listCounter = 1;

    const processedLines = lines.map((line, index) => {
      if (line.trim().startsWith('```')) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          return `${listContent}`;
        }
        inCodeBlock = !inCodeBlock;
        return line;
      }

      if (inCodeBlock) {
        return `<div class="${styles.previewCodeLine}">${escapeHtml(
          line
        )}</div>`;
      }

      const numberedMatch = line.match(
        /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/
      );
      const bulletMatch = line.match(/^[-*+]\s/);
      const isListItem = numberedMatch || bulletMatch;
      const isHeading = line.match(/^#{1,6}\s/);
      const isQuote = line.match(/^>\s/);
      const isEmpty = line.trim() === '';

      if (isHeading) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          const level = line.match(/^(#{1,6})\s/)?.[1].length || 1;
          const content = line.replace(/^#{1,6}\s/, '');
          return `${listContent}<h${level} class="${
            styles[`previewH${level}`]
          }">${content}</h${level}>`;
        }
        const level = line.match(/^(#{1,6})\s/)?.[1].length || 1;
        const content = line.replace(/^#{1,6}\s/, '');
        return `<h${level} class="${
          styles[`previewH${level}`]
        }">${content}</h${level}>`;
      }

      if (isQuote) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          const content = line.replace(/^>\s/, '');
          return `${listContent}<blockquote class="${styles.previewBlockquote}">${content}</blockquote>`;
        }
        const content = line.replace(/^>\s/, '');
        return `<blockquote class="${styles.previewBlockquote}">${content}</blockquote>`;
      }

      if (isListItem) {
        let content = line;

        const isNumbered = !!numberedMatch;
        const tag = isNumbered ? 'ol' : 'ul';

        let level = 0;
        let displayNumber = '';

        let nomerVstavit = '';

        if (isNumbered && numberedMatch) {
          const numberStr = numberedMatch[1];
          const levels = numberStr.split('.');
          for (let i = 0; i < levels.length; i += 1) {
            nomerVstavit = `${nomerVstavit}${levels[i]}.`;
          }
          level = levels.length - 1;
          displayNumber = levels[levels.length - 1];
          listCounter = parseInt(displayNumber, 10);

          content = content.replace(
            /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/,
            ''
          );
        } else if (bulletMatch) {
          level = 3;
          content = content.replace(/^[-*+]\s/, '');
        }

        content = processInlineMarkdown(content);

        const paddingLeft = 20 + level * 20;
        const showFullNumber = level > 0 && isNumbered ? nomerVstavit : '';
        const listStyle =
          level > 0 && isNumbered
            ? 'list-style: none; padding-left: ' +
              paddingLeft +
              'px; margin-left: 0;'
            : 'padding-left: ' + paddingLeft + 'px; margin-left: 0;';

        if (!inList || listTag !== tag || currentListLevel !== level) {
          if (inList) {
            const prevListContent = listBuffer.join('') + `</${listTag}>`;
            listBuffer = [];
            listTag = tag;
            inList = true;
            currentListLevel = level;

            const startAttr = isNumbered ? ` start="${listCounter}"` : '';
            listBuffer.push(
              `<${tag}${startAttr} class="${styles.previewList}" style="${listStyle}"><li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
            );
            return prevListContent;
          }
          listTag = tag;
          inList = true;
          currentListLevel = level;

          const startAttr = isNumbered ? ` start="${listCounter}"` : '';
          listBuffer.push(
            `<${tag}${startAttr} class="${styles.previewList}" style="${listStyle}"><li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
          );
          return '';
        }

        listBuffer.push(
          `<li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
        );
        return '';
      }

      if (inList) {
        inList = false;
        const listContent = listBuffer.join('') + `</${listTag}>`;
        listBuffer = [];
        currentListLevel = 0;
        listCounter = 1;

        if (isEmpty) {
          return `${listContent}<br>`;
        }

        return `${listContent}<p class="${
          styles.previewParagraph
        }">${processInlineMarkdown(line)}</p>`;
      }

      if (isEmpty) {
        return '<br>';
      }

      return `<p class="${styles.previewParagraph}">${processInlineMarkdown(
        line
      )}</p>`;
    });

    if (inList) {
      const listContent = listBuffer.join('') + `</${listTag}>`;
      processedLines.push(listContent);
    }

    return processedLines
      .join('\n')
      .replace(
        /\[(.*?)\]\(anatatlas:\/\/(.*?)\)/gim,
        `<a href="anatatlas://$2" class="${styles.anatomyLink}" title="Открыть в анатомическом атласе">$1</a>`
      );
  };

  // Обработчик монтирования редактора
  const handleEditorDidMount = (editor: any) => {
    editorRef.current = editor;
    editor.setPosition({ lineNumber: 1, column: 1 });
    editor.focus();
  };

  // Обработчик изменений
  const handleEditorChange = (value: string | undefined) => {
    if (value !== undefined) {
      setMarkdown(value);
    }
  };

  // Отмена изменений
  const undoChange = () => {
    if (historyIndex > 0) {
      const newIndex = historyIndex - 1;
      setHistoryIndex(newIndex);
      setMarkdown(history[newIndex]);
      setMarkdownEditor(history[newIndex]);
    }
  };

  // Вставка текста в редактор
  const insertText = (syntax: string, placeholder: string) => {
    if (!editorRef.current) return;

    const editor = editorRef.current;
    const selection = editor.getSelection();
    const model = editor.getModel();
    if (!model || !selection) return;

    const selectedText = model.getValueInRange(selection) || placeholder;
    const newText = syntax.replace('{text}', selectedText);

    editor.executeEdits('insert', [
      {
        range: selection,
        text: newText,
        forceMoveMarkers: true,
      },
    ]);

    editor.focus();
  };

  // Вставка ссылки на анатомический атлас
  const insertAnatomyLink = () => {
    if (!editorRef.current) return;

    const editor = editorRef.current;
    const selection = editor.getSelection();
    const model = editor.getModel();
    if (!model || !selection) return;

    let linkText = 'Название структуры';
    let linkId = 'structure-id';
    let linkTextLat = '';

    if (atlasAdd.atlasId !== '') {
      linkId = atlasAdd.atlasId;
      for (let i = 0; i < atlas.length; i += 1) {
        if (atlas[i].atlasId === atlasAdd.atlasId) {
          if (type === 0) {
            linkText = atlas[i].rus;
            linkTextLat = `(${atlas[i].latSmew})`;
          }
          if (type === 1) {
            linkText = atlas[i].rusPr;
            linkTextLat = `(${atlas[i].latPr})`;
          }
          if (type === 2) {
            linkText = atlas[i].rusSech;
            linkTextLat = `(${atlas[i].latSech})`;
          }
          if (type === 3) {
            linkText = atlas[i].rusGaivar;
            linkTextLat = `(${atlas[i].latGaivar})`;
          }
        }
      }
    }

    const selectedText = model.getValueInRange(selection);
    const anatomyLink = selectedText
      ? `[${selectedText}](anatatlas://?id=${linkId})`
      : `[${linkText} ${linkTextLat}](anatatlas://?id=${linkId})`;

    editor.executeEdits('insert', [
      {
        range: selection,
        text: anatomyLink,
        forceMoveMarkers: true,
      },
    ]);

    const position = selection.getStartPosition();
    editor.setPosition({
      lineNumber: position.lineNumber,
      column: position.column + anatomyLink.length,
    });
    editor.focus();
  };

  const insertTest = (testDtos: TestDto[]) => {
    if (!editorRef.current) return;

    const editor = editorRef.current;
    const selection = editor.getSelection();
    const model = editor.getModel();
    if (!model || !selection) return;

    // Формируем JSON строку с форматированием
    const jsonString = JSON.stringify(testDtos, null, 4);

    // Формируем финальный текст с qBlock
    const testText = `\n<qBlock/>\n${jsonString}\n---`;

    editor.executeEdits('insert', [
      {
        range: selection,
        text: testText,
        forceMoveMarkers: true,
      },
    ]);

    // Устанавливаем позицию курсора после вставленного текста
    const position = selection.getStartPosition();
    const lines = testText.split('\n');
    const lastLineLength = lines[lines.length - 1].length;

    editor.setPosition({
      lineNumber: position.lineNumber + lines.length - 1,
      column: lastLineLength + 1,
    });

    editor.focus();
  };

  // Получение данных атласа
  const getAtlas3D = async (route: string, key: string) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetAtlas3DNew(route, key);
    if (apiResult.isSuccess) {
      setAtlas(apiResult.data);
    } else if (apiResult.status !== 404) {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  // Получение конспекта
  const getAbstract3D = async (route: string, key: string) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetAbstract3DNew(
      route,
      key,
      `${type}`
    );
    if (apiResult.isSuccess) {
      const content = apiResult.data || '';
      setMarkdown(content);
      setMarkdownEditor(content);
      setHistory([content]);
      setHistoryIndex(0);
    } else if (apiResult.status !== 404) {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  // Сохранение текста
  const saveText = async (route: string, key: string) => {
    const textDto: TextDto = {
      text: markdown,
    };
    setMarkdownEditor(markdown);
    const apiResult: IApiResult = await apiSaveAbstract3DNew(
      route,
      key,
      `${type}`,
      textDto
    );
    if (apiResult.isSuccess) {
      setAlertProps({
        message: 'Данные записаны',
        severity: AlertSeverityEnum.info,
      });
      getAbstract3D(section ?? '', dto?.key ?? '');
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setType(newValue);
  };

  const handleClose = () => {
    onClose();
  };

  // Загрузка данных при открытии
  useEffect(() => {
    if (open) {
      getAtlas3D(section ?? '', dto?.key ?? '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Загрузка конспекта при смене типа или открытии
  useEffect(() => {
    if (open) {
      getAbstract3D(section ?? '', dto?.key ?? '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, type]);

  // Сохранение истории
  useEffect(() => {
    if (historyIndex === -1) return;

    const newHistory = history.slice(0, historyIndex + 1);
    if (newHistory[newHistory.length - 1] !== markdown) {
      const updatedHistory = [...newHistory, markdown];
      setHistory(updatedHistory);
      setHistoryIndex(updatedHistory.length - 1);
    }
  }, [markdown]);

  // Настройки Monaco Editor
  const editorOptions = {
    minimap: { enabled: false },
    fontSize: 14,
    lineHeight: 1.8,
    wordWrap: 'on' as const,
    automaticLayout: true,
    scrollBeyondLastLine: false,
    renderWhitespace: 'selection' as const,
    tabSize: 2,
    insertSpaces: true,
    fontFamily: 'Cascadia Code, Fira Code, JetBrains Mono, monospace',
    fontLigatures: true,
    suggest: { showWords: false },
    colorDecorators: true,
    padding: { top: 16, bottom: 16 },
  };

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: {
            backgroundColor: '#e7ebee',
            maxWidth: '100%',
            maxHeight: '100%',
          },
        }}
      >
        <BackDropDiv open={backDrop} />
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '24px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              {`3D конспект - ${dto?.key} ${dto?.title}`}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton title="Закрыть" size="small" onClick={handleClose}>
                <CloseIcon fontSize="large" sx={{ color: '#000000' }} />
              </IconButton>
            </Stack>
          </Stack>
          <header className={styles.editorHeader}>
            <div className={styles.toolbar}>
              <button
                className={styles.toolbarButton}
                onClick={undoChange}
                title="Отменить"
                disabled={historyIndex <= 0}
              >
                ↩️
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => saveText(section ?? '', dto?.key ?? '')}
                title="Сохранить"
              >
                💾
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('# {text}', 'Заголовок')}
                title="Заголовок H1"
              >
                H1
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('## {text}', 'Подзаголовок')}
                title="Подзаголовок H2"
              >
                H2
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('**{text}**', 'Жирный текст')}
                title="Жирный текст"
              >
                <strong>B</strong>
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('*{text}*', 'Курсив')}
                title="Курсив"
              >
                <em>I</em>
              </button>
              <Stack direction="row" spacing={1}>
                <button
                  className={styles.toolbarButton}
                  onClick={insertAnatomyLink}
                  title="Вставить ссылку"
                >
                  🔗
                </button>
                <MyAutoComplete
                  width="400px"
                  value={
                    atlasAdd.atlasId !== undefined
                      ? getNameArray(atlas, type)[
                          Object.values(getIdArray(atlas)).indexOf(
                            atlasAdd.atlasId
                          )
                        ]
                      : ''
                  }
                  onChange={(e, v) =>
                    setAtlasAdd({
                      ...atlasAdd,
                      atlasId:
                        getIdArray(atlas)[
                          Object.values(getNameArray(atlas, type)).indexOf(v)
                        ],
                    })
                  }
                  arrayList={getNameArray(atlas, type)}
                  size="small"
                  label="ID элемента"
                />
              </Stack>
              <button
                className={styles.toolbarButton}
                onClick={() => setOpedAddTest(true)}
                title="Вставить тест"
              >
                📝
              </button>
            </div>
          </header>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={type}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Текущий" value={0} />
              <Tab label="Привес" value={1} />
              <Tab label="Сапин" value={2} />
              <Tab label="Гайворонский" value={3} />
              <Tab label="Английский" value={4} />
            </Tabs>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: 0,
            '&:first-of-type': { paddingTop: 0 },
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden', // ← Отключаем прокрутку диалога
            flex: 1,
          }}
        >
          <div
            style={{
              overflow: 'auto',
            }}
            className={styles.markdownEditor}
          >
            <div className={styles.editorContainer}>
              <div className={styles.editorContent}>
                {/* Левая панель - редактор */}
                <div
                  className={`${styles.editorPanel} ${styles.splitPanel}`}
                  style={{
                    flex: '1 1 50%',
                    minWidth: '50%',
                    width: '50%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div className={styles.panelHeader}>
                    <h2 className={styles.panelTitle}>Редактор Markdown</h2>
                  </div>
                  <div
                    style={{
                      height: '100%',
                      overflow: 'auto',
                      flex: 1,
                      minHeight: 0,
                    }}
                  >
                    <Editor
                      language="markdown"
                      value={markdownEditor}
                      onChange={handleEditorChange}
                      onMount={handleEditorDidMount}
                      theme="vs-light"
                      height="100%"
                      options={editorOptions}
                    />
                  </div>
                </div>

                {/* Правая панель - preview */}
                <div
                  className={`${styles.previewPanel} ${styles.splitPanel}`}
                  style={{
                    flex: '1 1 50%',
                    minWidth: '50%',
                    width: '50%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div className={styles.panelHeader}>
                    <h2 className={styles.panelTitle}>
                      Предварительный просмотр
                    </h2>
                  </div>
                  <div
                    style={{
                      height: '100%',
                      overflow: 'auto',
                      flex: 1,
                      minHeight: 0,
                    }}
                    ref={previewRef}
                    className={styles.markdownPreview}
                    dangerouslySetInnerHTML={{
                      __html: renderMarkdown(markdown),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <DialogTestAddToAbstract
        open={openAddTest}
        onClose={() => setOpedAddTest(false)}
        addTest={insertTest}
        dto={dto}
      />
    </div>
  );
};

DialogAbstract3DNew.defaultProps = {
  isEdit: false,
  dto: undefined,
};
